"use client";

import React from "react";
import styles from "./Cta.module.scss";
import Image from "next/image";

const Cta = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.heading}>
            Ready to Transform Your E-commerce?
          </h2>
          <p className={styles.subheading}>
            Join the agentic commerce revolution and give your customers an
            AI-powered shopping experience they&apos;ll love.
          </p>
          <div className={styles.stats}>
            <div className={styles.statItem}>
              <Image
                src="/users.svg"
                alt="Users Up"
                width={32} // Adjust as needed
                height={32}
                className={styles.statIcon}
              />
              50+ businesses
            </div>
            <div className={styles.statItem}>
              {/* <TrendingUp className={styles.statIcon} /> */}
              <Image
                src="/increase.svg"
                alt="Trending Up"
                width={32} // Adjust as needed
                height={32}
                className={styles.statIcon}
              />
              40% avg. conversion increase
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
